"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENT_EDITOR_CUSTOM_CONFIGS = void 0;
exports.CONTENT_EDITOR_CUSTOM_CONFIGS = {
    draftJsToMd: {
        STRIKETHROUGH: "~~",
    },
    mdToDraftJs: {
        inlineStyles: {
            Delete: {
                type: "STRIKETHROUGH",
                symbol: "~~",
            },
        },
    },
    styleMap: {
        STRIKETHROUGH: {
            textDecoration: "line-through",
        },
    },
};
//# sourceMappingURL=constants.js.map